import React, { useContext, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import Bread from "../../common/Bread";
import "./branch.scss";
import BranchMap from "../../components/BranchMap";
import Loader from "../../common/Loader";
import BranchList from "../../components/BranchList";
import { LangContext } from "../../context/LangContext";

const Branch = () => {
  const [selected, setSelected] = useState({ id: null, lat: null, lng: null });
  const [daValley, setDaValley] = useState("inside");
  const { state } = useContext(LangContext);
  const nep = state.np;

  const handleReset = () => setSelected({ id: null, lat: null, lng: null });
  const callbackSelect = ({ id, lat, lng }) => setSelected({ id, lat, lng });

  const breadcrumList = {
    image: "",
    title: nep ? "शाखा स्थानहरू" : "Branch Locations",
    l1: nep ? "होम" : "Home",
    l2: nep ? "शाखाहरू" : "Branches",
    l3: "",
  };

  const { isLoading, isFetching, error, data } = useQuery({
    queryKey: ["branchData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/branch`)
        .then((res) => res.data),
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // Pick the correct language fields for display
  const branchData = data?.branch?.en.map((item, idx) => ({
    ...item,
    PageTitle: nep ? item.PageTitleNepali : item.PageTitle,
    Manager: nep ? item.ManagerNepali : item.Manager,
    Phone: nep ? item.PhoneNepali : item.Phone,
    POB: nep ? item.POBNepali : item.POB,
    mobile: nep ? item.mobile_nepali || item.mobile : item.mobile,
  }));

  // Filtered branch lists by Valley
  const insideValley = branchData.filter(
    (i) => i.Valley.toLowerCase() === "inside",
  );
  const outsideValley = branchData.filter(
    (i) => i.Valley.toLowerCase() === "outside",
  );
  const differentlyAbled = branchData.filter(
    (i) =>
      i.PageTitleNepali?.includes("ज्योतिनगर") ||
      i.PageTitleNepali?.includes("पेप्सिकोला") ||
      i.PageTitle?.toLowerCase().includes("jyotinagar") ||
      i.PageTitle?.toLowerCase().includes("pepsi cola") ||
      i.PageTitle?.toLowerCase().includes("pepsicola"),
  );
  const daInside = differentlyAbled.filter(
    (i) =>
      i.PageTitle?.toLowerCase().includes("pepsi cola") ||
      i.PageTitle?.toLowerCase().includes("pepsicola") ||
      i.PageTitleNepali?.includes("पेप्सिकोला"),
  );
  const daOutside = differentlyAbled.filter(
    (i) =>
      i.PageTitle?.toLowerCase().includes("jyotinagar") ||
      i.PageTitleNepali?.includes("ज्योतिनगर"),
  );

  return (
    <Bread data={breadcrumList}>
      <Tabs className="branchesPageTabContainer" defaultIndex={0}>
        <TabList className="branchesPageTabsButtonContainer">
          <Tab className="branchesPageTabButton" onClick={handleReset}>
            {nep ? "काठमाडौं उपत्यका भित्र" : "Inside Kathmandu Valley"}
          </Tab>
          <Tab className="branchesPageTabButton" onClick={handleReset}>
            {nep ? "उपत्यका बाहिर" : "Outside Valley"}
          </Tab>
          <Tab className="branchesPageTabButton" onClick={handleReset}>
            {nep ? "अपाङ्गमैत्री" : "Differently-abled friendly"}
          </Tab>
        </TabList>

        <TabPanel>
          <div className="branchesPageContainer">
            <BranchList data={insideValley} callbackSelect={callbackSelect} />
            <div className="branchesMapContainer">
              <BranchMap data={insideValley} selected={selected} />
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="branchesPageContainer">
            <BranchList data={outsideValley} callbackSelect={callbackSelect} />
            <div className="branchesMapContainer">
              <BranchMap data={outsideValley} selected={selected} />
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="daSubFilter">
            <button
              className={`daSubFilterBtn ${daValley === "inside" ? "active" : ""}`}
              onClick={() => setDaValley("inside")}
            >
              {nep ? "काठमाडौं उपत्यका भित्र" : "Inside Kathmandu Valley"}
            </button>
            <button
              className={`daSubFilterBtn ${daValley === "outside" ? "active" : ""}`}
              onClick={() => setDaValley("outside")}
            >
              {nep ? "उपत्यका बाहिर" : "Outside Valley"}
            </button>
          </div>
          <div className="branchesPageContainer">
            <BranchList data={daValley === "inside" ? daInside : daOutside} callbackSelect={callbackSelect} />
            <div className="branchesMapContainer">
              <BranchMap key={daValley} data={daValley === "inside" ? daInside : daOutside} selected={selected} />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </Bread>
  );
};

export default Branch;
